module.exports = __webpack_public_path__ + "img/huodong.f12c49f6.png";